// Determine the base URL based on the environment
export const getBaseUrl = (): string => {
  // Check if we're in production (superadmin.parkwithparallel.com)
  if (window.location.hostname === "superadmin.parkwithparallel.com") {
    return "https://api.parkwithparallel.com";
  }
  // Default to development environment
  return "http://localhost:8085/ParkingWithParallel";
};

export const BASE_URL = getBaseUrl();
